import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';

const LMSAdminPage = loadable(() => import('./LMSAdminPage'));

export default {
  id: 'lms_admin',
  title: 'LMS Admin',
  icon: 'book',
  route: 'lms-admin',
  defaultRoute: 'lms-admin/program-intake',
  hasDynamicDefaultRoute: true,
  group: 'administration',
  component: LMSAdminPage,
  order: 8,
  structure,
};
